<ng-wizard [config]="config">

  <ng-wizard-step [title]="'สปสช.เขต รายงานผลการออกติดตาม'" [description]="'&nbsp;'" [state]="stepStates.normal"></ng-wizard-step>

  <ng-wizard-step [title]="'ฝ่ายทะเบียนตรวจสอบผลรายงานการออกติดตาม'" [description]="'&nbsp;'" [state]="stepStates.normal">
    <div class="row mb-3">
      <div class="col-xl-12 mt-3 offset-xl-1">
        <p>ประเภทรายงาน : {{ARBITRARY_TYPE(srmHospitalArbitrary.arbitraryType)}}</p>
        <p>{{srmHospitalArbitrary?.hmainOp?.province?.zone?.name}}  หน่วยบริการ : {{srmHospitalArbitrary?.hmainOp?.hcode}} {{srmHospitalArbitrary?.hmainOp?.hname}}</p>
        <p>รอบการแจ้งเตือน : {{srmHospitalArbitrary.round}}</p>
        <p>จำนวนข้อมูลที่ตรวจพบลงทะเบียนพลการ {{srmHospitalArbitrary.auditDetected}} รายการ จาก {{srmHospitalArbitrary?.items?.length}} รายการ</p>
        <p>หมายเลขแจ้งเตือน : {{srmHospitalArbitrary.notiNumber}}</p>
      </div>
    </div>
    <div class="mt-5" *ngIf="true;then footer_step1"></div>
  </ng-wizard-step>

  <ng-wizard-step [title]="'อยู่ระหว่างการตรวจสอบของฝ่ายทะเบียน'" [description]="'&nbsp;'" [state]="stepStates.normal">
    <div *ngIf="true;then step2"></div>
  </ng-wizard-step>

  <ng-wizard-step [title]="'สรุปผลการตรวจสอบ'" [description]="'&nbsp;'" [state]="stepStates.normal">
    <div *ngIf="true;then step2"></div>
  </ng-wizard-step>

</ng-wizard>

<ng-template #footer_step1>
  <div class="row mb-3">
    <div class="offset-xl-2 col-xl-10">
      <button type="submit" class="btn btn-success me-2" (click)="saveStep1()">
        บันทึก
      </button>
      <button class="btn btn-secondary mr-1" type="button" (click)="reset()">
        ยกเลิก
      </button>
    </div>
  </div>
</ng-template>

<ng-template #step2>
  <div class="row mb-3">
    <div class="col-xl-11 mt-3 offset-xl-1">
      <p>ประเภทรายงาน : {{ARBITRARY_TYPE(srmHospitalArbitrary.arbitraryType)}}</p>
      <p>{{srmHospitalArbitrary?.hmainOp?.province?.zone?.name}}  หน่วยบริการ : {{srmHospitalArbitrary?.hmainOp?.hcode}} {{srmHospitalArbitrary?.hmainOp?.hname}}</p>
      <p>รอบการแจ้งเตือน : {{srmHospitalArbitrary.round}}</p>
      <p>จำนวนข้อมูลที่ตรวจพบลงทะเบียนพลการ {{srmHospitalArbitrary.auditDetected}} รายการ จาก {{srmHospitalArbitrary?.items?.length}} รายการ</p>
      <p>หมายเลขแจ้งเตือน : {{srmHospitalArbitrary.notiNumber}}</p>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-xl-11 form-group row offset-xl-1">
      <label for="adit-check-date" class="col-form-label">ลงวันที่</label>
      <div class="col-sm-2">
        <gt-ng-datepicker [maxDate]="currentDate" name="adit-check-date" required id="adit-check-date" [disabled]="srmHospitalArbitrary.arbitraryStatus !== 'INSPECTION_OF_REGISTRY_OFFICE'"
                          [(ngModel)]="srmHospitalArbitrary.auditCheckDate"></gt-ng-datepicker>
        <gt-error [forId]="'adit-check-date'" [field]="'auditCheckDate'"></gt-error>
      </div>
    </div>
  </div>
  <div *ngIf="true;then footer_step2"></div>
</ng-template>

<ng-template #footer_step2>
  <div class="row mt-5 mb-3" *ngIf="srmHospitalArbitrary.arbitraryStatus === 'INSPECTION_OF_REGISTRY_OFFICE'">
    <div class="offset-xl-2 col-xl-10">
      <button type="submit" class="btn btn-success me-2" (click)="saveStep2()">
        บันทึก
      </button>
      <button class="btn btn-secondary mr-1" type="button" (click)="reset()">
        ยกเลิก
      </button>
    </div>
  </div>
</ng-template>

